export function mergeFormExtend(data) {
    let obj = {};
    if (Object.prototype.toString.call(data) !== "[object Object]") return obj;
    if (data.extends && Array.isArray(data.extends) && data.extends.length > 0) {
        obj.extendMap = {};

        data.extends.forEach(item => {
            if (typeof item.value !== "undefined" && item.key) {
                obj.extendMap[item.key] = item.value;
            }
        });
    }

    if (Object.prototype.toString.call(data.forms) === "[object Object]") {
        obj = Object.assign({}, data.forms, obj);
    }
    return obj;
}

// 更新返回的数据更新原有数据，去除脏数据
export function objUpdate(data, newData) {
    if (
        Object.prototype.toString.call(data) === "[object Object]" &&
        Object.prototype.toString.call(newData) === "[object Object]"
    ) {
        Object.keys(data).forEach(item => {
            data[item] = newData[item];
        });
    }
}

export function cloneDeep(value, hash = new WeakMap()) {
    if (typeof value != "object") {
        return value;
    }
    if (value instanceof RegExp) return new RegExp(value);
    if (value instanceof Date) return new Date(value);
    let v = hash.get(value);
    if (v) {
        return v;
    }
    let instance = new value.constructor();
    hash.set(value, instance);
    for (let key in value) {
        if (value.hasOwnProperty(key)) {
            instance[key] = cloneDeep(value[key], hash);
        }
    }
    return instance;
}
